import { atom } from 'infrastructure/state/jotai.wrapper'
import { googleUserAtom, getFilesRecursive2 } from 'infrastructure/googleDrive'

export const currentTreeIdsAtom = atom<{ treeId?: string; versionId?: string }>(
  {},
)

export const doingSomethingAtom = atom(false)

export const gDriveFilesAtom = atom(async (get) => {
  const guser = get(googleUserAtom)

  if (!guser.credential?.accessToken) return []

  // getFilesRecursive2 returns a flat list of all files with their paths
  const files = await getFilesRecursive2(
    guser.credential.accessToken,
    'https://drive.google.com/drive/folders/1B2DVps2pnBJQCFpFD4JGa8_i4BX7EMhv',
  )

  return files
})
